export const apiRoot = "https://atl-server.onrender.com/api";
//"http://api-server:4000/api"
// "http://localhost:4000/api";
// 'https://bdadb.azurewebsites.net/api'



